<script>
import HeaderVue from '../header_vue/headervue.vue';
import { sharedData } from '../../../static/js/vue_specific/sharedData';

export default {
  props: [
    'breadcrumbItems',
    'fetchMenuUrl',
    'pageId',
    'querySearchUrl',
    'subsite',
    'subsiteBackUrl',
    'subsiteBackText',
    'subsiteTitle',
    'goBackText',
    'goBackMainMenuText',
    'favoritesLinktext',
    'favoritesOpentext',
    'favoritesClosetext',
    'favoritesRemovetext',
    'subsiteRootUrl',
    'subsiteRootTitle',
    'subsitePageId',
    'json',
    'addRemoveToolLinktext',
    'addRemoveToolLinkurl',
    'addRemoveToolLinkicon',
    'addRemoveToolLinkcustomclass',
    'staticSearchUrl',
    'saveBookmarkText',
    'removeBookmarkText',
    'menu',
  ],
  components: {
    HeaderVue,
    //VUE3: FixedHeader,
  },
  data() {
    return {
      showModal: false,
      showFav: false,
      showMenu: false,
      showSearch: false,
      cookieName: 'miun_favourites',
      shared: sharedData,
      favorites: [],
      currentPage: {},
    };
  },
  created() {
    if (
      typeof $cookies.get(this.shared.cookieNameCart) !== typeof undefined &&
      $cookies.get(this.shared.cookieNameCart) !== null
    ) {
      this.shared.cart = $cookies.get(this.shared.cookieNameCart);
    } else {
      this.shared.cart = new Array();
    }
  },
  mounted() {
    this.currentPage = this.getCurrentPage();
    this.readStoredConfig();
    window.addEventListener('favorites.add', (evnt) => {
      if (evnt.details) this.addFavorite(evnt.details);
      else this.addFavorite(this.currentPage.pageId);
    });
    window.addEventListener('favorites.remove', (evnt) => {
      if (evnt.details) this.removeFavorite(evnt.details);
      else this.removeFavorite(this.currentPage.pageId);
    });
  },
  methods: {
    readStoredConfig() {
      const configElement = document.getElementById('favouritesConfig');
      if (configElement) {
        const config = JSON.parse(configElement.innerHTML);
        this.addUrl = config.addUrl;
        this.removeUrl = config.removeUrl;
        this.updateUrl = config.updateUrl;
        if (config.isAuthenticated) {
          this.favorites = config.favourites;
          this.storeCookie();
        } else {
          if (
            typeof $cookies.get(this.cookieName) !== typeof undefined &&
            $cookies.get(this.cookieName) !== null
          ) {
            this.favorites = $cookies.get(this.cookieName);
          } else {
            this.favorites = new Array();
          }
        }
      }
      this.updateIsSetAsFavorite();
    },
    getCurrentPage() {
      let pageId = document
        .querySelector("meta[name='pageId']")
        .getAttribute('content');
      let pageTitle = document
        .querySelector("meta[property='og:title']")
        .getAttribute('content');
      let pageUrl = document
        .querySelector("meta[property='og:url']")
        .getAttribute('content');

      return {
        pageId: Number(pageId),
        pageTitle: pageTitle,
        pageUrl: pageUrl,
      };
    },
    addFavorite(pageId) {
      this.favorites.push(this.currentPage);
      fetch(this.addUrl + '?pageId=' + pageId, {
        method: 'post',
      });
      this.storeCookie();
    },
    removeFavorite(pageId) {
      if (!pageId) {
        pageId = document
          .querySelector("meta[name='pageId']")
          .getAttribute('content');
      }

      this.favorites = this.favorites.filter((v, i, a) => v.pageId !== pageId);
      fetch(this.removeUrl + '?pageId=' + pageId, {
        method: 'post',
      });
      this.storeCookie();
    },
    getCurrentPage() {
      var pageId = document
        .querySelector("meta[name='pageId']")
        .getAttribute('content');
      var pageTitle = document
        .querySelector("meta[property='og:title']")
        .getAttribute('content');
      var pageUrl = document
        .querySelector("meta[property='og:url']")
        .getAttribute('content');
      return {
        pageId: pageId,
        pageTitle: pageTitle,
        pageUrl: pageUrl,
      };
    },
    storeCookie() {
      $cookies.set(
        this.cookieName,
        JSON.stringify(this.favorites),
        9999,
        '/',
        window.location.host,
        true,
        'None'
      );
      this.updateIsSetAsFavorite();
    },
    updateIsSetAsFavorite() {
      if (this.favorites.length) {
        for (let i = 0; i < this.favorites.length; i++) {
          if (this.favorites[i].pageId == this.currentPage.pageId) {
            this.shared.isFavorite = true;
            return;
          }
        }
      }
      this.shared.isFavorite = false;
    },
    favoritesUpdated(event) {
      if (event.moved) {
        fetch(
          this.updateUrl +
            '?pageId=' +
            event.moved.element.pageId +
            '&order=' +
            event.moved.newIndex,
          {
            method: 'post',
          }
        );
      }
      return this.storeCookie();
    },
  },
};
</script>
<template>
  <HeaderVue
    :save-bookmark-text="saveBookmarkText"
    :remove-bokmark-text="removeBookmarkText"
    :breadcrumb-items="breadcrumbItems"
    :fetch-menu-url="fetchMenuUrl"
    :query-search-url="querySearchUrl"
    :page-id="pageId"
    :json="json"
    :subsite="subsite"
    :subsite-back-url="subsiteBackUrl"
    :go-back-text="goBackText"
    :go-back-main-menu-text="goBackMainMenuText"
    :add-remove-tool-linktext="addRemoveToolLinktext"
    :add-remove-tool-linkurl="addRemoveToolLinkurl"
    :add-remove-tool-linkicon="addRemoveToolLinkicon"
    :add-remove-tool-linkcustomclass="addRemoveToolLinkcustomclass"
    :subsite-back-text="subsiteBackText"
    :subsite-title="subsiteTitle"
    :favorites-linktext="favoritesLinktext"
    :favorites-opentext="favoritesOpentext"
    :favorites-closetext="favoritesClosetext"
    :favorites-removetext="favoritesRemovetext"
    :subsite-root-url="subsiteRootUrl"
    :subsite-root-title="subsiteRootTitle"
    :subsite-page-id="subsitePageId"
    :menu="menu"
    :static-search-url="staticSearchUrl"></HeaderVue>
</template>
